import script from "./FortnoxActivation.vue?vue&type=script&setup=true&lang=js"
export * from "./FortnoxActivation.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__